import { render, staticRenderFns } from "./TempleteConteudoDialog.vue?vue&type=template&id=620ed9ac&scoped=true"
import script from "./TempleteConteudoDialog.vue?vue&type=script&lang=js"
export * from "./TempleteConteudoDialog.vue?vue&type=script&lang=js"
import style0 from "./TempleteConteudoDialog.vue?vue&type=style&index=0&id=620ed9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ed9ac",
  null
  
)

export default component.exports